"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doubleDecodeURI = exports.doubleEncodeURI = void 0;
// TODO: SHORT多分いらなくなる
// 単純にencodeURIComponentだけ使うとエラーになる場合があったため
// 1. encodeURIComponentでencode
// 2. 1をさらにencodeURIでencode
// する。
// https://google.comのようなURLを含む場合はやる必要がありそう
// @see
const doubleEncodeURI = (raw) => {
    return encodeURI(encodeURIComponent(raw));
};
exports.doubleEncodeURI = doubleEncodeURI;
// encodeの逆
const doubleDecodeURI = (encoded) => {
    return decodeURIComponent(decodeURI(encoded));
};
exports.doubleDecodeURI = doubleDecodeURI;
//# sourceMappingURL=uriDoubleCoder.js.map